module.exports = __webpack_public_path__ + "img/AirPack.136afa41.png";